import React from 'react';
import { useState, useEffect, useContext } from "react";
import { MyContext } from "../../context";

function TicketClosedCard(props){

  const {RightLinkSelection, updateRightLinkSelection, updateInstallationLinkSelection, updateLinkSelection } = useContext(MyContext);
  //const active = "BIcon active";
  //const notActive = "BIcon";

  const [ticketid, setTicketId] = useState("")


  const [active, setActive] = useState("")
  const [active1, setActive1] = useState("")

  const take = () => {
    props.setMondayid(props.Mondayid)
    
    //setTicketId("")
  }


  //console.log(props.Mondayid)

 

  const MoreInfo = () => {
    props.setTicketFault(props.fault)
    props.setTicketDate(props.date)
    props.setTicketDescription(props.description)
    props.setTicketInverter(props.inverter)
    props.setTicketBattery(props.type)
    props.setTicketLocation(props.location)
    props.setTicketName(props.name)
   // setActive1(props.Mondayid)

    //props.setActiveticket(true)
   
  }

    return (
       
        <>
        
      
<div className={ props.Mondayid === active1? "cardActive" :  "card"} style={{width: "18rem;", marginBottom: "30px"}}>


<div className="card-body" style={{cursor:"pointer"}} onClick={MoreInfo}>
<div style={{display: "flex"}}>

    <span style={{width:"91%", display:"flex"}}>

<span style={{marginRight:"40px"}}>
<div style={{display: "flex"}}>
    
    <p className="card-title"><strong>{props.name}</strong></p></div>
  
    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Logged:</strong>  {props.date}</span>
    
   
    </div>



</span>
<span style={{marginRight:"40px"}}>

    <p><strong>Closed </strong></p>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">error</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>2 Jan 2023</span>
  
  </div>

</span>


{/* */}

<span style={{marginRight:"40px"}}>

    <p><strong>Battery </strong></p>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>Z-Range</span>
  
  </div>

</span>


<span style={{marginRight:"0px", width:"50%"}}>

    <p><strong>Ticket Number </strong></p>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">123</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>00345934989</span>
  
  </div>

</span>










</span>

<span style={{width:"18%", paddingRight:"20px"}}>

<span className="BIcon3" onClick={take} style={{height:"100%" , margin: "0px",  paddingTop:"6px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"7px"}} >confirmation_number</span> <span style={{paddingTop:"12px", paddingLeft:"5px"}}>View Ticket</span></span>

</span>

{/* 

<span style={{width:"14%", paddingRight:"20px"}}>

<span className="BIcon3" onClick={() => updateInstallationLinkSelection("AllBatteries")} style={{height:"100%" , margin: "0px",  paddingTop:"13px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"0px"}} >battery_5_bar</span> <span style={{paddingTop:"2px", paddingLeft:"5px"}}>All Cells</span></span>

</span>

<span  style={{width:"14%", paddingRight:"20px"}}>

<span className="BIcon3" onClick={() => updateInstallationLinkSelection("Information")} style={{height:"100%" , margin: "0px",  paddingTop:"13px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"0px"}} >info</span> <span  style={{paddingTop:"2px", paddingLeft:"5px"}}>Cells Info </span></span>

</span>
*/}



</div>


</div>
</div>

             

        </>
    )
}

export default TicketClosedCard;